module.exports = __webpack_public_path__ + "img/logo_printer_1.51138aa7.png";